<template>      
<div key=7>    

          <div v-if="loadingOrg == 0" class="card-body">
            
            <div class="row">
              <div class="col-12">
                <self-building-square-spinner :animation-duration="6000" :size="60" color="#0E1698" style="margin: auto"/></span>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="text-center" style="text:#0E1698">Loading your Organization</div>
              </div>
            </div>
          </div>

          <div v-if="loadingOrg == 1" class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="h5 text-muted">Organization (Payer)</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="">{{orgDetails.name}}</div>
              </div>
              <div class="col-12">
                <div class="">{{orgDetails.addr1}}</div>
              </div>
              <div v-if="orgDetails.addr2 != null && orgDetails.addr2 != ''" class="col-12">
                <div class="">{{orgDetails.addr2}}</div>
              </div>
              <div class="col-12">
                <div class="">{{orgDetails.city}}</div>
              </div>
              <div class="col-12 mb-3">
                <div class="">{{orgDetails.state}}, {{orgDetails.zip}}</div>
              </div>
              <div class="col-12">
                <a href="#" class="small" @click="changeOrg">Change Organization</a>
              </div>
            </div>
          </div>

          <div v-if="loadingContact == 0" class="card-body">
            
            <div class="row">
              <div class="col-12">
                <self-building-square-spinner :animation-duration="6000" :size="60" color="#0E1698" style="margin: auto"/></span>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="text-center" style="text:#0E1698">Loading your Contact</div>
              </div>
            </div>
          </div>

          <div v-if="loadingContact == 1" class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="h5 text-muted">Contact (Customer)</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="">{{contactDetails.f_name}} {{contactDetails.l_name}}</div>
              </div>
              <div v-if="contactDetails.pri_phone != null && contactDetails.pri_phone != ''" class="col-12">
                <div class="">{{contactDetails.pri_phone}}</div>
              </div>
              <div class="col-12 mb-3">
                <div class="">{{contactDetails.pri_email}}</div>
              </div>
              
              <div class="col-12">
                <a href="#" class="small" @click="changeContact">Change Contact</a>
              </div>
            </div>
          </div>
          
</div>
</template>


<script>
  import { SelfBuildingSquareSpinner  } from 'epic-spinners'
import {store} from '../../../stores/quote-builder-main-store.js'


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      loadingOrg: 0,
      loadingContact: 0,
      orgDetails: [],
      contactDetails: [],
    }
  },
  computed: {

    
  },
  watch: {
    
  },
  mounted() {
    this.getOrgDetails();
    this.getContactDetails();
  },
  methods: {
    getOrgDetails(){
      var _this = this;
      _this.loadingOrg = 0;
      axios.get('/utility/user/org/getorgdetails/' + _this.prop2[0])
        .then(function (response) {
          var a = response.data.data;
          _this.orgDetails = a;
          _this.loadingOrg = 1;
        });
    },
    getContactDetails(){
      var _this = this;
      _this.loadingContact = 0
      axios.get('/utility/user/contact/getspecificcontact/' + _this.prop2[1])
        .then(function (response) {
          var a = response.data.data;
          _this.contactDetails = a;
          _this.loadingContact = 1;
        });
    },
    changeOrg() {
      var _this = this;
      _this.$emit('onRecipSecondary', [ 'builder-organization' ])
    },
    changeContact() {
      var _this = this;
      _this.$emit('onRecipSecondary', [ 'builder-contact' ])
    },

  },    
  components:{
    SelfBuildingSquareSpinner,
  },
  filters: {

  }
}
</script>
